<template>
	<div class="home">
		<Header />
		<TopSection heading="Edit Company" user="J K" />
		edit company here
	</div>
</template>

<script>
	import TopSection from '../components/TopSection.vue'
	import Header from '../components/Header.vue'
	export default {
		name: 'App',
		components: {
			Header, TopSection
		}
	}

</script>

